<div
    class="panel-height"
    [class]="connieUiService.isHistoryOpen() ? 'grid grid-template-cols-1-2' : 'flex flex-col'">
    @if (connieUiService.isHistoryOpen()) {
        <div class="history-panel">
            <div class="history-panel__header p-4 pt-5">
                <div class="flex flex-row justify-between">
                    <span class="text-base font-semibold">{{ 'chatHistory' | transloco }}</span>
                    <app-button
                        [icon]="['far', 'close']"
                        (click)="closeHistoryPanel()" />
                </div>
                <app-search
                    [hasDebounce]="true"
                    (searchValue)="searchValueChange($event)" />
            </div>
            <div class="history-panel__list">
                @if (connieUiService.state().loading) {
                    <app-loading />
                } @else {
                    @for (thread of connieUiService.threads(); track thread.id) {
                        <div
                            class="thread-card"
                            [class.active]="currentThreadId() === thread.id">
                            <span class="text-sm">
                                {{ thread.name | capitalize }}
                            </span>
                            <span class="text-xs text-on-surface">
                                {{ 'createdAt' | transloco }}:
                                {{ thread.createdAt | date: translateService.localDate() }}
                            </span>
                            <app-button
                                [disabled]="currentThreadId() === thread.id"
                                [label]="'open' | transloco"
                                (onClick)="openThread(thread.id)" />
                        </div>
                    }
                }
            </div>
        </div>
    }
    <div
        #copilotPanel
        class="flex bg-on-primary overflow-hidden relative flex-col h-full"
        id="copilot-panel">
        @if (isLoading()) {
            <app-loading />
        } @else if (!hasConnieDataInformation()) {
            <app-no-data-to-display />
        }
    </div>
</div>
